import { motion } from "framer-motion";

const services = [
  {
    title: "Approachable",
    description:
      "Without concerning about location or time zone,feel free to connect with us to know the progress of your projects. We will keep you informed about the development processes, dealings, workflows and delivery.",
    icon: (
      // CPU / chip with pins icon
      <svg viewBox="0 0 64 64" fill="none" className="w-14 h-14" xmlns="http://www.w3.org/2000/svg">
        <rect x="18" y="18" width="28" height="28" rx="4" stroke="#3B82F6" strokeWidth="2" />
        <rect x="23" y="23" width="18" height="18" rx="2" stroke="#3B82F6" strokeWidth="1.6" />
        {/* Top pins */}
        <line x1="24" y1="18" x2="24" y2="12" stroke="#3B82F6" strokeWidth="1.8" strokeLinecap="round" />
        <line x1="32" y1="18" x2="32" y2="12" stroke="#3B82F6" strokeWidth="1.8" strokeLinecap="round" />
        <line x1="40" y1="18" x2="40" y2="12" stroke="#3B82F6" strokeWidth="1.8" strokeLinecap="round" />
        {/* Bottom pins */}
        <line x1="24" y1="46" x2="24" y2="52" stroke="#3B82F6" strokeWidth="1.8" strokeLinecap="round" />
        <line x1="32" y1="46" x2="32" y2="52" stroke="#3B82F6" strokeWidth="1.8" strokeLinecap="round" />
        <line x1="40" y1="46" x2="40" y2="52" stroke="#3B82F6" strokeWidth="1.8" strokeLinecap="round" />
        {/* Left pins */}
        <line x1="18" y1="24" x2="12" y2="24" stroke="#3B82F6" strokeWidth="1.8" strokeLinecap="round" />
        <line x1="18" y1="32" x2="12" y2="32" stroke="#3B82F6" strokeWidth="1.8" strokeLinecap="round" />
        <line x1="18" y1="40" x2="12" y2="40" stroke="#3B82F6" strokeWidth="1.8" strokeLinecap="round" />
        {/* Right pins */}
        <line x1="46" y1="24" x2="52" y2="24" stroke="#3B82F6" strokeWidth="1.8" strokeLinecap="round" />
        <line x1="46" y1="32" x2="52" y2="32" stroke="#3B82F6" strokeWidth="1.8" strokeLinecap="round" />
        <line x1="46" y1="40" x2="52" y2="40" stroke="#3B82F6" strokeWidth="1.8" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    title: "True Professionals",
    description:
      "Client satisfaction is our priority. Hence, we keep your business goals in mind and leave no stone unturned to achieve them. We maintain global standards while delivering software solutions.",
    icon: (
      // Monitor with person/profile card icon
      <svg viewBox="0 0 64 64" fill="none" className="w-14 h-14" xmlns="http://www.w3.org/2000/svg">
        <rect x="8" y="10" width="48" height="34" rx="4" stroke="#3B82F6" strokeWidth="2" />
        <line x1="8" y1="18" x2="56" y2="18" stroke="#3B82F6" strokeWidth="1.6" />
        <line x1="24" y1="44" x2="24" y2="52" stroke="#3B82F6" strokeWidth="1.8" strokeLinecap="round" />
        <line x1="40" y1="44" x2="40" y2="52" stroke="#3B82F6" strokeWidth="1.8" strokeLinecap="round" />
        <line x1="18" y1="52" x2="46" y2="52" stroke="#3B82F6" strokeWidth="1.8" strokeLinecap="round" />
        {/* Profile card inside screen */}
        <circle cx="28" cy="30" r="5" stroke="#3B82F6" strokeWidth="1.6" />
        <rect x="36" y="25" width="12" height="2.5" rx="1.2" fill="#3B82F6" opacity="0.5" />
        <rect x="36" y="30" width="8" height="2.5" rx="1.2" fill="#3B82F6" opacity="0.35" />
        <rect x="36" y="35" width="10" height="2.5" rx="1.2" fill="#3B82F6" opacity="0.25" />
      </svg>
    ),
  },
  {
    title: "Salivating Ideas",
    description:
      "We understand the limitations your business is facing and the access to highly skilled global professionals, so that together we can make a difference and analyze the business era and drive future business growth.",
    icon: (
      // Laptop/book with chip pins on top icon
      <svg viewBox="0 0 64 64" fill="none" className="w-14 h-14" xmlns="http://www.w3.org/2000/svg">
        <rect x="8" y="22" width="48" height="28" rx="4" stroke="#3B82F6" strokeWidth="2" />
        <line x1="8" y1="30" x2="56" y2="30" stroke="#3B82F6" strokeWidth="1.6" />
        <line x1="4" y1="50" x2="60" y2="50" stroke="#3B82F6" strokeWidth="1.8" strokeLinecap="round" />
        {/* Lines inside screen */}
        <line x1="16" y1="38" x2="30" y2="38" stroke="#3B82F6" strokeWidth="1.5" strokeLinecap="round" />
        <line x1="16" y1="43" x2="26" y2="43" stroke="#3B82F6" strokeWidth="1.5" strokeLinecap="round" />
        {/* Chip pins on top */}
        <rect x="24" y="12" width="16" height="12" rx="2.5" stroke="#3B82F6" strokeWidth="1.6" />
        <line x1="28" y1="12" x2="28" y2="8" stroke="#3B82F6" strokeWidth="1.6" strokeLinecap="round" />
        <line x1="32" y1="12" x2="32" y2="8" stroke="#3B82F6" strokeWidth="1.6" strokeLinecap="round" />
        <line x1="36" y1="12" x2="36" y2="8" stroke="#3B82F6" strokeWidth="1.6" strokeLinecap="round" />
        <line x1="28" y1="24" x2="28" y2="22" stroke="#3B82F6" strokeWidth="1.6" strokeLinecap="round" />
        <line x1="32" y1="24" x2="32" y2="22" stroke="#3B82F6" strokeWidth="1.6" strokeLinecap="round" />
        <line x1="36" y1="24" x2="36" y2="22" stroke="#3B82F6" strokeWidth="1.6" strokeLinecap="round" />
      </svg>
    ),
  },
   {
    title: "Unmatched Quality",
    description:
      "Our high-quilty and global standards are what our clients vouch for. We deploy seamless software products for dynamic business needs, ensuring constant support, and maximum ROI.",
    icon: (
      // Laptop/book with chip pins on top icon
      <svg viewBox="0 0 64 64" fill="none" className="w-14 h-14" xmlns="http://www.w3.org/2000/svg">
        <rect x="8" y="10" width="48" height="34" rx="4" stroke="#3B82F6" strokeWidth="2" />
        <line x1="8" y1="18" x2="56" y2="18" stroke="#3B82F6" strokeWidth="1.6" />
        <line x1="24" y1="44" x2="24" y2="52" stroke="#3B82F6" strokeWidth="1.8" strokeLinecap="round" />
        <line x1="40" y1="44" x2="40" y2="52" stroke="#3B82F6" strokeWidth="1.8" strokeLinecap="round" />
        <line x1="18" y1="52" x2="46" y2="52" stroke="#3B82F6" strokeWidth="1.8" strokeLinecap="round" />
        {/* Profile card inside screen */}
        <circle cx="28" cy="30" r="5" stroke="#3B82F6" strokeWidth="1.6" />
        <rect x="36" y="25" width="12" height="2.5" rx="1.2" fill="#3B82F6" opacity="0.5" />
        <rect x="36" y="30" width="8" height="2.5" rx="1.2" fill="#3B82F6" opacity="0.35" />
        <rect x="36" y="35" width="10" height="2.5" rx="1.2" fill="#3B82F6" opacity="0.25" />
      </svg>
    ),
  },
];

const containerVariants = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.14 } },
};

const cardVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.55, ease: "easeOut" } },
};

export default function CreativeServicesSection() {
  return (
    <section className="w-full bg-[#f5f7fa] py-8 lg:py-12 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">

        {/* Header */}
        <div className="flex flex-col items-center text-center mb-14">
          <motion.div
            initial={{ opacity: 0, y: -12 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.45 }}
            className="mb-5"
          >
            <span className="inline-block px-6 py-2 rounded-full border border-gray-300 bg-white text-gray-500 text-xs font-semibold tracking-widest uppercase shadow-sm">
              Creative Services
            </span>
          </motion.div>

          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.55, delay: 0.1 }}
            className="text-[2rem] sm:text-[2.7rem] font-extrabold text-gray-900 leading-tight"
          >
            Your Partner In{" "}
            <span className="text-orange-500">Digital</span> Success
          </motion.h2>
        </div>

        {/* Cards */}
     <motion.div
  className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-7"
  variants={containerVariants}
  initial="hidden"
  whileInView="visible"
  viewport={{ once: true, margin: "-60px" }}
>
  {services.map((service) => (
    <motion.div
      key={service.title}
      variants={cardVariants}
      whileHover={{
        y: -8,
        boxShadow: "0 20px 48px rgba(59,130,246,0.10)",
      }}
      transition={{ type: "spring", stiffness: 260, damping: 22 }}
      className="bg-white rounded-3xl  py-3 flex flex-col items-center gap-3 shadow-sm border border-gray-100 group transition-all duration-300 hover:border-blue-200"
    >
      {/* Icon */}
      <motion.div
        whileHover={{ scale: 1.1, rotate: 3 }}
        transition={{ type: "spring", stiffness: 300, damping: 20 }}
        className="text-blue-600 "
      >
        {service.icon}
      </motion.div>

      {/* Title */}
      <h3 className="text-gray-900 font-bold text-[1.1rem] leading-snug  text-center">
        {service.title}
      </h3>

      {/* Description */}
      <p className="text-gray-500 text-[0.91rem] leading-relaxed  pl-4 text-balance">
        {service.description}
      </p>
      {/* Button */}
      {/* <motion.a
        href={service.link || "#"}
        whileHover={{
          backgroundColor: "#1e40af",
          color: "#ffffff",
          borderColor: "#1e40af",
        }}
        whileTap={{ scale: 0.96 }}
        transition={{ duration: 0.2 }}
        className="mt-2 inline-flex items-center justify-center px-7 py-2.5 rounded-full border-2 border-gray-900 text-gray-900 font-semibold text-[0.93rem] transition-all duration-300"
      >
        Touch More +
      </motion.a> */}
    </motion.div>
  ))}
</motion.div>

      </div>
    </section>
  );
}